/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_F2Inputs */

const en_mk_sol_konsultan_f2 = /** @type {(inputs: Mk_Sol_Konsultan_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data & Analytics, Product, General`)
};

const id_mk_sol_konsultan_f2 = /** @type {(inputs: Mk_Sol_Konsultan_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data & Analitik, Product, Umum`)
};

/**
* | output |
* | --- |
* | "Data & Analytics, Product, General" |
*
* @param {Mk_Sol_Konsultan_F2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_f2 = /** @type {((inputs?: Mk_Sol_Konsultan_F2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_F2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_f2(inputs)
	return en_mk_sol_konsultan_f2(inputs)
});